export default {"src":"/_next/static/media/conclusion-icon-circular.02f58cec.svg","height":137,"width":137,"blurWidth":0,"blurHeight":0};